import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import localForage from 'localforage';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import LogRocket from 'logrocket';
import sagas from './redux/sagas';
import Router from './components/common/Router';
import { interceptExpiredToken } from './api/axios';
// import registerServiceWorker from './registerServiceWorker';
import reducers from './redux/reducers';
import shareSessionBetweenTabs, { listenForLogout } from './utils/sessionHandler';
import { hideFocusStylesForMouse, closeTooltipOnTouch } from './utils/utils';
import * as usersActionTypes from './redux/actions/usersActionTypes';

LogRocket.init('qazjik/rta-medsafety', {
  network: {
    requestSanitizer: (request) => {
      if (/authenticate|register|change-password|set-password|users\/\d+/.test(request.url)) {
        // Scrub the body if it has a password in it
        request.body = null;
      }
      return request;
    },
  },
});

// Inherit session if other tracer tool tabs are open
shareSessionBetweenTabs();

// Refresh the previous session
if (localStorage.jwt) sessionStorage.setItem('jwt', localStorage.jwt);
// For the PDF generator, grab the token from the query params
if (/jwt=([^&]*)/.test(window.location.search)) sessionStorage.setItem('jwt', window.location.search.match(/jwt=([^&]*)/)[1]);

closeTooltipOnTouch();
hideFocusStylesForMouse();

const persistConfig = {
  key: 'root',
  storage: localForage,
  debug: true,
};

const persistedReducer = persistReducer(persistConfig, reducers);

// Export React so the dev tools can find it
if (window === window.top) {
  window.React = React;
}

const sagaMiddleware = createSagaMiddleware();
// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(persistedReducer, composeEnhancers(
  applyMiddleware(
    sagaMiddleware,
    LogRocket.reduxMiddleware({
      actionSanitizer(action) {
        // Scrub passwords from actions
        switch (action.type) {
          case usersActionTypes.LOGIN:
          case usersActionTypes.JOIN:
          case usersActionTypes.SET_PASSWORD:
            return {
              ...action,
              password: undefined,
            };
          case usersActionTypes.CHANGE_PASSWORD:
            return {
              ...action,
              oldPassword: undefined,
              newPassword: undefined,
            };
          default:
            return action;
        }
      },
    }),
  ),
));
export default store;
sagaMiddleware.run(sagas);

const persistor = persistStore(store);

listenForLogout(store);
interceptExpiredToken(store);

// Set app element so main content can be hidden for screen readers when modals are open
ReactModal.setAppElement('#root');

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router />
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js